<template>
  <div class="card box-card">
    <div class="card-heading">
      <h4 class="card-title text-center">Alerts</h4>
    </div>
    <div v-for="(alert_obj,priority) in alerts" class="card-group" v-bind:key="priority">
      <div class="card alert-card" v-bind:class="getPriorityClass(priority)">
        <div class="card-heading alert-heading d-flex" data-toggle="collapse" v-bind:href="'#'+priority">
          <h5 class="card-title">{{ getPriorityName(priority) }} alerts</h5>
          <h5 class="ml-auto">({{alert_obj.total}})</h5>
        </div>
        <div v-bind:id="priority" class="card-collapse collapse">
          <ul class="list-group list-group-flush" v-for="(alert,index) in sortAlertByCount(alert_obj.alerts)" v-bind:key="priority + '-' + index">
            <li class="d-flex list-group-item">
              <div class="alert-name">{{alert.name}}</div>
              <div class="ml-auto alert-count">({{alert.count}})</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertsPriorityList',
  props: [
    'alerts'
  ],
  methods: {
    getPriorityName: function (priority) {
      if (priority === 'P1') {
        return 'critical'
      } else if (priority === 'P2') {
        return 'downgraded'
      } else if (priority === 'P3') {
        return 'task'
      } else if (priority === 'P4') {
        return 'warning'
      } else if (priority === 'P5') {
        return 'informational'
      }
    },
    getPriorityClass: function (priority) {
      return {
        critical: (priority === 'P1'),
        downgraded: (priority === 'P2'),
        task: (priority === 'P3'),
        warning: (priority === 'P4'),
        informational: (priority === 'P5')
      }
    },
    sortAlertByCount: function (alerts) {
      return alerts.slice().sort((a, b) => b.count - a.count)
    }
  }
}
</script>

<style scoped src='../../assets/stylesheet/alerts.css'></style>



// WEBPACK FOOTER //
// src/components/Alerts/AlertsPriorityList.vue